import { composeFieldPath } from '@northfork/basics'
import { Basis, MvtBasisSelection } from '../../mvt-basis.model'
import { TransferPurchaseInfo } from '../../single-transaction/security-transfer/transfer-purchase-info.model'
import { RequestMode } from '../../validation-response.model'
import { BulkExternalData } from '../bulk-misc-model'
import {
  BulkSecurityTransferTransactionDerived,
  TransactionTypeLabel,
} from '../bulk-transaction'
export const securityField = composeFieldPath([] as BulkSecurityTransferRow[])

export interface BulkSecurityTransferRow extends BulkExternalData {
  //transaction details
  rowId: string
  rowNumber?: string
  assetId: string
  securityId?: number
  entryDate: string
  accountId: string
  tranType: string
  units: string
  balanceUnits?: number
  factor?: number //security
  transferPrice: string
  validityStatus: 'valid' | 'invalid' | 'warning' | 'inactive' | 'intermediate'
  errorMessageMap: Map<string, string[]>
  legacyOrigTranId?: number
  transactionId?: string
  legacyTranId?: number
  inventoryType: string
  collateralBroker?: string
  sleeveAccountId?: number
  mvtBases?: { [k: string]: Basis }
  mvtBasisSelection?: MvtBasisSelection[]
  mvtBasisSelectionText?: string
  clientLotId?: string | null | ''
  transferSpecificLotId?: string
  orderId?: string
  prepaidInterest?: string
  interestDue?: string
  amount?: number
  // PVAL-26104: the server-derived proceeds amount for the CURRENT derive cycle,
  // deliberately a separate slot from `amount` above. Before this split the two
  // sources shared one slot, so a derive that returned no amount left the
  // previous cycle's value in place and the save command carried a stale
  // proceeds. This slot is cleared at the top of every derive (reset-then-apply)
  // and resolved against `amount` with nullish semantics at save time.
  derivedAmount?: number
  transactionBasis?: string
  transactionTypeLabel?: TransactionTypeLabel
  basisId?: number
}

export interface ErrorMessageRow {
  field: string
  errorMessages: string[]
}

export interface BulkDerivedRequestEntry {
  transaction: BulkSecurityTransferTransactionDerived
  tpiDataMap: { [key: string]: TransferPurchaseInfo }
}

export interface BulkDerivedRequest {
  tranData: BulkDerivedRequestEntry[]
  accountBases: { [key: string]: Basis[] }
}

export interface BulkDerivedResponseSecurityTransfer {
  tpiDerivedFields: { [key: string]: DerivedTpiData }
}

export interface DerivedTpiData {
  amortStartPrice?: number
  origCost?: number
  origPrice?: number
  expectedOrigPrice?: number
  factor?: number
  origYield?: number
  origAccruedInt?: number
  amortStartCost?: number
}

export interface TransactionDerivedFields {
  transferPrice?: number
  factor?: number
  marketValue?: number
  currentUnits?: number
  amount?: number
}

export interface BulkSecurityTransferDerivedResponse {
  basisDerivedField: { [key: string]: BasisDerivedFields }
  securityIdMap: { string: number }
}

export interface BasisDerivedFields {
  tpiDerivedFields: { [key: string]: DerivedTpiData }
  transactionDerivedFields: TransactionDerivedFields
}

export interface BulkSecurityTransferDerivedRequest {
  tranData: BulkDerivedRequestEntry[]
  accountBases: { [key: string]: Basis[] }
  requestMode: RequestMode
}
